import * as React from 'react';

declare const rootUrl: string;

interface ConfigureStepsProps {
    onNext: () => void;
    onBack: () => void;
}

export const ConfigureSteps = ({ onNext, onBack }: ConfigureStepsProps) => {
    return (
        <>
            <div className="modal-body">
                <div className="row">
                    <div className="col-md-12">
                        <h2 className="text-primary">Configure Device</h2>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <ol className="posh-list">
                            <li>Turn the device on using the stylus to slide the power switch</li>
                            <li>Wait until the main menu, containing 'START RECORDING' and 'SETUP' menu options, is displayed</li>
                            <li>Select 'SETUP' then 'LIVE BARGRAPH'</li>
                            <li>Ensure both the microphone and chest sensor bar graphs are responding to noise<br /><br /><img src={rootUrl + '/Images/Wizards/vitalojak1-levels.png'} alt="" /></li>
                            <li>Return to the 'SETUP' menu then select 'DATE/TIME'</li>
                            <li>Select 'SET DATE' then adjust to match the current date</li>
                            <li>Return to the 'SETUP' menu</li>
                            <li>Select 'SET TIME' then adjust to match the current time</li>
                            <li>Return to the main menu</li>
                        </ol>
                    </div>
                    <div className="col-md-6">
                        <img style={{ width: '100%', maxWidth: '320px' }} src={rootUrl + '/Images/Wizards/vitalojak1-screen-flow.png'} alt="" />
                    </div>
                </div>
            </div>
            <div className="modal-footer">
                <button className="btn btn-primary" onClick={onNext}>Next</button>
                <button className="btn btn-primary btn-outline" onClick={onBack}>Back</button>
            </div>
        </>
    );
}
